import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const AnimatedBackground = () => {
  const bgRef = useRef();

  useEffect(() => {
    gsap.to(bgRef.current, {
      backgroundPosition: "100% 100%",
      duration: 30,
      repeat: -1,
      ease: "linear"
    });
  }, []);

  return (
    <div
      ref={bgRef}
      className="fixed top-0 left-0 w-full h-full -z-10"
      style={{
        backgroundImage: "radial-gradient(#8A2BE2 1px, transparent 1px)",
        backgroundSize: "40px 40px",
        opacity: 0.05
      }}
    />
  );
};

export default AnimatedBackground;
